import { useActivityBuilderContext } from 'approot/activity-builder/activity-builder.context';
import {
  COMPONENT_TEMPLATE_IMAGE_STIMULUS_ID,
  DRAFT_ACTION_COMPONENT_IMAGE_UPDATE,
  IMAGE,
} from 'global/constants';
import { StimulusLibrary } from '../shared/stimulus-library';
import ImageEditDrawer from './image-edit-drawer';
import { Props } from './image.constants';
import {
  MultiView,
  MultiViewPage,
} from 'approot/shared/layout/layout-multi-view';
import ImageCreateOptions from './image-create-options';
import { useBatchComponentUpdateContext } from '../shared/batch-component-update.context';
import { useSnackbar } from 'approot/shared/snackbar-notification/snackbar-notification.hooks';
import { PrimaryButton } from 'approot/shared/styles/buttons';
import ImageEditPreviewDrawer from './image-edit-preview-drawer';
import { useFindComponentDimensions } from '../component.hooks';

const ImageSettings = (props: Props) => {
  const { closeDrawer, activeComponent } = useActivityBuilderContext();
  const { showError } = useSnackbar();
  const { elementDimensionLabel } = useFindComponentDimensions(props.id);
  const defaultIndex =
    !props.properties.stimulusId &&
    activeComponent?.meta?.templateId === COMPONENT_TEMPLATE_IMAGE_STIMULUS_ID
      ? 1
      : 0;

  const { updateComponentProperties, loading } =
    useBatchComponentUpdateContext();

  return (
    <MultiView defaultIndex={defaultIndex}>
      {multiviewProps => (
        <>
          <MultiViewPage
            index={0}
            {...multiviewProps}
            onClose={closeDrawer}
            renderItem={() => (
              <>
                {props.properties.stimulusId ? (
                  <ImageEditPreviewDrawer
                    componentId={props.id}
                    sectionId={props.sectionId}
                    contentId={props.lessonId}
                    stimulusId={props.properties.stimulusId}
                    componentImage={props}
                  />
                ) : props.properties.image?.original ||
                  props.stimulusResourceProperties?.image?.original ? (
                  <ImageEditDrawer {...props} />
                ) : (
                  <ImageCreateOptions
                    id={props.id}
                    contentId={props.contentId}
                    sectionId={props.sectionId}
                    elementDimensionLabel={elementDimensionLabel}
                    goForward={multiviewProps.goForward}
                  />
                )}
              </>
            )}
          />
          <MultiViewPage
            index={1}
            {...multiviewProps}
            onClose={multiviewProps.goBack}
            renderItem={() => (
              <StimulusLibrary
                stimulusType={IMAGE}
                title="Image"
                componentId={props.id}
                canGoBack
                onGoBack={multiviewProps.goBack}
                renderSubmit={selectedStimulus => (
                  <PrimaryButton
                    data-selector="btn-choose-stimulus"
                    type="button"
                    loading={loading}
                    disabled={!selectedStimulus || loading}
                    onClick={() =>
                      selectedStimulus &&
                      updateComponentProperties({
                        input: {
                          sectionId: props.sectionId,
                          componentId: props.id,
                          componentData: {
                            type: props.type,
                            sort: props.sort,
                            properties: {
                              stimulusId: selectedStimulus.id,
                              showCaptionOnLesson: false,
                              altText: null,
                            },
                          },
                          addDraftAction: DRAFT_ACTION_COMPONENT_IMAGE_UPDATE,
                        },
                        typename: 'ActivitiesImageComponent',
                        isSaveImmediate: true,
                        onCompleted: () => {
                          closeDrawer();
                        },
                        onError: () =>
                          showError(
                            'There was an error selecting this stimulus resource'
                          ),
                      })
                    }
                  >
                    Choose Stimulus
                  </PrimaryButton>
                )}
                {...props}
              />
            )}
          />
        </>
      )}
    </MultiView>
  );
};

export default ImageSettings;
